// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"bat_a","InstagramEmbed__mask":"bat_b bhm_bi bhm_bo bhm_wz"};